import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'prototypes/securedCard/app.module.scss';
import AppChrome from 'prototypes/securedCard/components/AppChrome';
import CardFace from 'prototypes/securedCard/components/CardFace';
import RateChips from 'prototypes/securedCard/components/RateChips';
import { formatMoney } from 'prototypes/securedCard/formatMoney';
import { PrototypePath } from 'prototypes/securedCard/paths';
import { SAVINGS_APY_LABEL } from 'prototypes/securedCard/prototypeAssumptions';
import { useStory } from 'prototypes/securedCard/StoryContext';

const DashboardStep = () => {
  const navigate = useNavigate();
  const { projection, ledger, resetStory } = useStory();
  const recent = ledger.slice(-4);

  return (
    <AppChrome
      step={PrototypePath.Dashboard}
      title="Your card"
      subtitle="Savings from payroll, spending power from those savings, and the grocery run already paid."
    >
      <div className={styles.stack}>
        <CardFace />
        <div className={styles.figureList}>
          <div className={`${styles.figure} ${styles.figurePrimary}`}>
            <div>
              <p className={styles.figureLabel}>Available to spend</p>
              <p className={styles.figureHint}>Stops at what your savings can cover</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.availableAfterPaymentCents)}</p>
          </div>
          <div className={styles.figure}>
            <div>
              <p className={styles.figureLabel}>Savings</p>
              <p className={styles.figureHint}>After the automatic payment</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.savingsAfterPaymentCents)}</p>
          </div>
          <div className={styles.figure}>
            <div>
              <p className={styles.figureLabel}>Interest</p>
              <p className={styles.figureHint}>{SAVINGS_APY_LABEL}, tracked as earnings</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.interestCents)}</p>
          </div>
          <div className={styles.figure}>
            <div>
              <p className={styles.figureLabel}>Cashback</p>
              <p className={styles.figureHint}>Typical flat rate, tracked as rewards</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.cashbackCents)}</p>
          </div>
        </div>
        <RateChips />
        <div>
          <p className={styles.choiceTitle}>Recent activity</p>
          {recent.map((entry) => (
            <div key={entry.id} className={styles.ledgerRow}>
              <div>
                <p className={styles.ledgerTitle}>{entry.title}</p>
                <p className={styles.ledgerMeta}>{entry.dateLabel}</p>
              </div>
              <p className={entry.amountCents < 0 ? styles.amountOut : styles.amountIn}>
                {formatMoney(entry.amountCents)}
              </p>
            </div>
          ))}
        </div>
        <button type="button" className={styles.secondaryButton} onClick={() => navigate(PrototypePath.Transactions)}>
          See every transaction
        </button>
        <button
          type="button"
          className={styles.quietButton}
          onClick={() => {
            resetStory();
            navigate(PrototypePath.Welcome);
          }}
        >
          Start over
        </button>
      </div>
    </AppChrome>
  );
};

export default DashboardStep;
